module.exports = __webpack_public_path__ + "static/media/plus.aa3f699c.svg";